document.addEventListener('contextmenu', (e) => {
	if (e.target.closest('img')) {
		e.preventDefault();
	}
});